<template>
  <div class="wt-player-audio">
    <button
      class="wt-play-button"
      :disabled="disabled ? true : false"
      @click.prevent="toggle"
    >
      <i
        class="wticon"
        :class="[isPlaying ? 'wticon-stop2' : 'wticon-play3']"
      ></i>
    </button>
    <div class="wt-player-audio-controls">
      <div class="wt-player-audio-top-control">
        <input
          type="range"
          min="0"
          :disabled="disabled"
          :value="currentTime"
          ref="timeline"
          @mousedown="pause"
          @mouseup="play"
          @input="seekTo"
          @mousemove="setRangesCss($event, currentTime / 100)"
        />
      </div>
      <div class="wt-player-audio-bottom-control">
        <span class="wt-player-audio-time-indicator"
          >{{ timeText }} / {{ durationText }}</span
        >
        <div class="wt-player-audio-volume-control">
          <i
            class="wticon"
            @click="mute"
            :class="
              +volume === 0 ? 'wticon-volume-mute2' : 'wticon-volume-high2'
            "
          ></i>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            v-model="volume"
            ref="volume"
            @change="setRangesCss"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    src: {
      type: String,
      default: '',
    },

    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  data: function () {
    return {
      audio: null,
      disabled: true,
      isPlaying: false,
      volume: this.options.volume || 1,
      oldVolume: this.volume,
      currentTime: this.defaultTime,
      duration: 0,
    };
  },

  computed: {
    durationText: function () {
      return app.seconds2Minutes(this.duration);
    },

    defaultTime: function () {
      return this.options.startTime || 0;
    },

    timeText: function () {
      return app.seconds2Minutes(this.duration * (this.currentTime / 100));
    },
  },

  created: function () {
    this.srcChanged();
  },

  mounted: function () {
    this.setRangesCss(this.$refs.volume);
    this.setRangesCss(this.$refs.timeline);
  },

  beforeDestroy: function () {
    this.handleEvents('remove');
    this.reset();
    this.audio.src = '';
    this.audio = null;
  },

  watch: {
    src: function () {
      this.srcChanged();
    },

    volume: function (newVal, oldVal) {
      this.oldVolume = oldVal;
      this.setVolume(newVal);
    },

    duration: function () {
      this.onTimeupdate();
    },
  },

  methods: {
    getDefaultEventsList: function () {
      return [
        'error',
        'canplaythrough',
        'playing',
        'pause',
        'loadedmetadata',
        'timeupdate',
      ];
    },

    srcChanged: function () {
      if (this.audio) {
        this.reset();
      } else {
        this.create();
        this.handleEvents('add');
      }
    },

    reset: function () {
      this.disabled = true;
      this.isPlaying = false;
      this.audio.pause();
      this.audio.currentTime = this.currentTime = this.defaultTime;
      this.audio.src = this.src;
      this.audio.load();
    },

    create: function () {
      this.audio = new Audio(this.src);
      this.currentTime = this.defaultTime;
    },

    handleEvents: function (action) {
      const events = this.getDefaultEventsList();
      let fn;

      _.each(events, (eventName) => {
        fn = this['on' + _.capitalize(eventName)];

        if (_.isFunction(fn)) {
          if (action === 'add') {
            this.audio.addEventListener(eventName, fn, false);
          } else if (action === 'remove') {
            this.audio.removeEventListener(eventName, fn, false);
          }
        }
      });
    },

    /* audio events callbacks */
    onError: function () {
      console.log('error!!!!');
      this.duration = 0;
    },

    onCanplaythrough: function () {
      this.disabled = false;
      this.$emit('canplaythrough');
    },

    onLoadedmetadata: function () {
      this.duration = this.audio.duration;
    },

    onPlaying: function () {
      this.isPlaying = true;
    },

    onTimeupdate: function () {
      this.currentTime = this.duration
        ? (100 / this.duration) * this.audio.currentTime
        : 0;
      this.setRangesCss(this.$refs.timeline, this.currentTime / 100);
    },

    onPause: function () {
      this.isPlaying = false;
    },

    /* audio and player controls */
    play: function () {
      this.audio.play();
    },

    pause: function () {
      this.audio.pause();
    },

    toggle: function () {
      this.isPlaying ? this.pause() : this.play();
    },

    mute: function () {
      let volume = 0;

      if (+this.volume === 0) {
        volume = +this.oldVolume;
      }

      this.volume = volume;
      this.setVolume(volume);

      app.Vue.nextTick(() => {
        this.setRangesCss(this.$refs.volume);
      });
    },

    setVolume: function (newVolume) {
      this.audio.volume = newVolume;
    },

    seekTo: function (e) {
      this.audio.currentTime = this.duration * (+e.target.value / 100);
    },

    setRangesCss: function (range, presetValue) {
      const rangeEl = range.target ? range.target : range;
      const value = presetValue ? presetValue : rangeEl.value;

      rangeEl.style.backgroundImage = ` -webkit-gradient(
                linear,
                left top,
                right top,
                color-stop(${value}, #00aaf5),
                color-stop(${value}, #c5cace)
         )`.normalizeSpace();
    },
  },
};
</script>
